import { CanEditEmailDocument, CanEditEmailQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCanEditEmail = (
  variables: CanEditEmailQueryVariables,
  options?: { skip?: boolean }
) => {
  const { data, loading } = useQuery(CanEditEmailDocument, {
    variables,
    skip: options?.skip,
  })

  return {
    canEditEmail:
      data?.users.personalInfosConnection.edges[0]?.node?._policies?.editProfileEmail.can,
    loading,
  }
}
